import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import propTypes from 'prop-types';
import { useEffect, useState } from 'react';

function PrepagoTable({
  estimativeReminders,
  monthlyIncrease,
  reminderValue,
  isFirstMonth,
  prepaid,
  setPrepaid,
  lastPrepaid,
  setTotalPrepago,
}) {
  const percentageToPrepaid = 0.6;
  const [monthlyIncrementAmount, setMonthlyIncrementAmount] = useState();
  const [monthlyIncrementValue, setMonthlyIncrementValue] = useState();
  const [nextMonthRemindersAmount, setNextMonthRemindersAmount] = useState();
  const [nextMonthRemindersValue, setNextMonthRemindersValue] = useState();

  const getTotals = () => {
    const estimativeRemindersValue = parseFloat(estimativeReminders || 0);
    const monthlyIncreaseValue = parseFloat(monthlyIncrease / 100 || 0);
    const monthlyAmount = estimativeRemindersValue * monthlyIncreaseValue;
    const newPrepaid = (estimativeRemindersValue + monthlyAmount) * reminderValue;
    if (!((estimativeRemindersValue === 0 || reminderValue === 0) && prepaid !== 0))
      setPrepaid(newPrepaid * percentageToPrepaid);
    setMonthlyIncrementAmount(monthlyAmount.toFixed(2));
    setMonthlyIncrementValue((monthlyAmount * percentageToPrepaid * reminderValue).toFixed(2));
    setNextMonthRemindersAmount(estimativeRemindersValue.toFixed(2));
    setNextMonthRemindersValue(
      (estimativeRemindersValue * percentageToPrepaid * reminderValue).toFixed(2),
    );
  };

  const getTotalPrepago = () => {
    setTotalPrepago(parseFloat(prepaid || 0));
    return parseFloat(prepaid || 0);
  };

  useEffect(() => {
    getTotals();
  }, [isFirstMonth, estimativeReminders, monthlyIncrease]);

  const rows = [
    {
      name: 'Incremento mensual',
      cantidad: monthlyIncrementAmount,
      cantidadPrepago: monthlyIncrementAmount * percentageToPrepaid,
      total: monthlyIncrementValue,
    },
    {
      name: `Estimado recordatorios ${isFirstMonth ? 'actual' : 'actuales'}`,
      cantidad: nextMonthRemindersAmount,
      cantidadPrepago: nextMonthRemindersAmount * percentageToPrepaid,
      total: nextMonthRemindersValue,
    },
    {
      name: 'PREPAGO MES SIGUIENTE',
      total: getTotalPrepago()?.toFixed(2),
      style: { backgroundColor: '#90EE90' },
    },
    {
      name: 'PREPAGO MES ANTERIOR',
      total: parseFloat(lastPrepaid || 0)?.toFixed(2),
      style: { backgroundColor: '#FFCCCC' },
    },
  ];

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align="center">
              Cantidad
              <br /> Recordatorios
            </TableCell>
            <TableCell align="center">
              Cantidad
              <br />
              Prepago (60%)
            </TableCell>
            <TableCell align="center">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name} style={row.style}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="center">{row.cantidad}</TableCell>
              <TableCell align="center">{row.cantidadPrepago?.toFixed(2)}</TableCell>
              <TableCell align="center">$ {row.total}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const Props = {
  estimativeReminders: propTypes.number,
  monthlyIncrease: propTypes.string,
  reminderValue: propTypes.number,
  isFirstMonth: propTypes.bool,
  prepaid: propTypes.string,
  setPrepaid: propTypes.func,
  lastPrepaid: propTypes.string,
  setTotalPrepago: propTypes.func,
};
PrepagoTable.propTypes = Props;

export default PrepagoTable;
